module.exports = __webpack_public_path__ + "img/7.4f156102.png";